import { useState } from "react";
import { useLocation } from "wouter";
import { useMutation } from "@tanstack/react-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useToast } from "@/hooks/use-toast";
import { signInWithGoogle } from "@/lib/firebase";
import { SiGoogle } from "react-icons/si";
import { Loader2 } from "lucide-react";
import { useTitle } from "@/hooks/use-title";

export default function AuthPage() {
  useTitle("Sign In");
  const [, setLocation] = useLocation();
  const { toast } = useToast();
  const [error, setError] = useState<string | null>(null);

  const googleAuth = useMutation({
    mutationFn: signInWithGoogle,
    onSuccess: () => {
      toast({ title: "Signed in successfully" });
      setLocation("/");
    },
    onError: (error: Error) => {
      setError(error.message);
      toast({
        title: "Error signing in",
        description: error.message,
        variant: "destructive",
      });
    },
  });

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <Card className="w-[350px] bg-zinc-900 border-zinc-800">
        <CardHeader>
          <CardTitle className="text-white">Welcome to BitcoinPuzzles</CardTitle>
          <CardDescription className="text-zinc-400">
            Sign in to access your personalized content
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Button
            className="w-full"
            onClick={() => {
              setError(null);
              googleAuth.mutate();
            }}
            disabled={googleAuth.isPending}
          >
            {googleAuth.isPending ? (
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
            ) : (
              <SiGoogle className="mr-2 h-4 w-4" />
            )}
            Sign in with Google
          </Button>

          {error && (
            <p className="mt-4 text-sm text-red-500 text-center">
              {error}
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}